import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../Button/Button';
import { ReactComponent as Logo } from '../../../assets/FlintandSteel-logo.svg';
import Section from '../../Sections/Section';
import { animateNavShow } from '../Navigation/NavigationAnimation';

import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const checkPageHeightAndAnimate = () => {
      const pageHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const scrollThreshold = viewportHeight; 

      if (pageHeight <= scrollThreshold) {
        const header = document.querySelector('.fixed-header');
        if (header) {
          animateNavShow(header);
        }
      }
    };

    setTimeout(checkPageHeightAndAnimate, 100);

  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    scrollToTop();

    if (location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.dispatchEvent(new Event('scrollToForm'));
    } else {
      navigate('/', { state: { scrollToForm: true } });
    }
  };

  return (
    <footer className="footer">
      <Section className="gap-l footer">
        <div className="footer-logo-wrapper">
          <Link to="/" onClick={handleLogoClick}>
            <Logo className="logo-footer"/>
          </Link>
          <div className="seperator"></div>
        </div>
        <nav className="footer-nav">
          <div className="link-column">
            <p className="footer-p">Pagina's</p>
            <Button variant="link" as={Link} to="/portfolio">Portfolio</Button>
            <Button variant="link" as={Link} to="/about">Over ons</Button>
            <Button variant="link" onClick={handleContactClick}>Contact</Button>
          </div>
          <div className="link-column">
            <p className="footer-p">Projecten</p>
            <Button variant="link" as={Link} to="/portfolio/13e598b6-c031-80bb-98b3-db3a45524c37">De herstellers</Button>
          </div>
        </nav>
        <div className="seperator"></div>
        <div className="footer-info">
          <p className="color80">© FlintandSteel VOF {currentYear}</p>
          <p className="color80">kvk: 4485410</p>
          <Button variant="button-footer-link" as={Link} to="/legal/legal">Privacystatement</Button>
          <Button variant="button-footer-link" as={Link} to="/legal/cookies">Cookies</Button>
        </div>
      </Section>
    </footer>
  );
};

export default Footer;